import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBZjLEd23ln4Vk-NZb662_yz-AvreM9bNA",
  authDomain: "kcards-3453b.firebaseapp.com",
  projectId: "kcards-3453b",
  storageBucket: "kcards-3453b.appspot.com",
  messagingSenderId: "547012462311",
  appId: "1:547012462311:web:a8b114ad88d687c0760442",
  measurementId: "G-WB958KB75R",
};

// initialize firebase
const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth();

const db = getFirestore();

export { auth, db };
